import { Close } from '@mui/icons-material'
import { Box, Modal, Skeleton } from '@mui/material'
import { useAuth } from 'contexts/auth'
import { useAuthentications } from 'contexts/authentications'
import { useDashboard } from 'contexts/dashboard'
import { useSidebar } from 'contexts/sidebar'
import { IOrganizationUserDTO } from 'data/dtos/authentication/i-organization-user-dto'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import api from 'services/api'
import useContract from 'store/contracts'
import { formatCNPJ } from 'utils/is-valid-cnpj'
import ChangeOrganizationButton from '../change-organization-button'
import { useStyles } from './styles'

type THelpModal = {
  openModal: boolean
  setOpenModal: () => void
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  Height: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  overflow: 'hidden',
  padding: '1.5rem',
}

const ChangeOrganizationModal = ({ openModal, setOpenModal }: THelpModal) => {
  const [orgsByUser, setOrgsByUser] = useState<IOrganizationUserDTO[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const classes = useStyles()
  const history = useHistory()

  const { onReloadMenu } = useSidebar()
  const { changeOrganization } = useAuth()
  const { handleResetActualOrganization } = useContract()
  const { refetchValidate } = useAuthentications()
  const { setChangeOnCurrentOrg } = useDashboard()

  const getOrganizationsByUser = async () => {
    setIsLoading(true)
    try {
      const { data } = await api.get('/organizations-users/find-organization-by-user-id')
      await new Promise((resolve) => setTimeout(resolve, 400))

      setOrgsByUser(data.data)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleChangeOrganization = async (organizationId: string) => {
    try {
      setIsLoading(true)
      await changeOrganization(organizationId)

      onReloadMenu()
      refetchValidate()
      handleResetActualOrganization()
      setOpenModal()
      window.location.reload()
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
      setChangeOnCurrentOrg(organizationId)
    }
  }

  useEffect(() => {
    if (openModal) {
      getOrganizationsByUser()
    }
  }, [openModal])

  return (
    <Modal
      open={openModal}
      onClose={setOpenModal}
    >
      <Box sx={style}>
        <Box className={classes.titleAndDescriptionContainer}>
          <Box className={classes.titleAndCloseButton}>
            <span className={classes.title}>Selecione a organização</span>
            <Close
              className={classes.closeBtn}
              onClick={setOpenModal}
            />
          </Box>
        </Box>

        <Box className={classes.organizations}>
          {isLoading ? (
            <Skeleton
              variant='rectangular'
              animation={'wave'}
              width={'100%'}
              height={60}
            />
          ) : (
            orgsByUser?.map((org, index) => {
              const organizationType = org.organizationType?.name || ''
              const isSeller = organizationType.toLowerCase().includes('seller')

              // For Seller/Corretora: only show eSocial chip if certificate is required
              // For others (Buyer/RH): show eSocial chip based on normal logic
              const showESocialChip = isSeller ? org.certificateRequired : true
              const eSocialStatus = !org.certificateRequired || (org.certificateUploadDate && org.certificateUploadDate.length > 0 ? true : false)

              return (
                <ChangeOrganizationButton
                  key={index}
                  organizationName={org.corporateName}
                  organizationFederalTaxId={formatCNPJ(org.federalTaxId as string)}
                  organizationType={organizationType}
                  eSocialStatus={eSocialStatus}
                  showESocialChip={showESocialChip}
                  handleChangeOrg={() => handleChangeOrganization(org.id)}
                />
              )
            })
          )}
        </Box>
      </Box>
    </Modal>
  )
}

export default ChangeOrganizationModal
